<template>
	<div>
		<PageHeader
			:data="{
				name: route,
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>

		<router-link class="btn btn-primary mb-2 active" :to="'/municipalities'">
			🏙️ Municipalities
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/contacts'">
			📙 Municipalities Contacts
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipality-map'">
			📍 Map
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipalities-missing'">
			Municipalities Missing
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipality-map/polygons'">
			📐 Map Polygons
		</router-link>

		<div v-if="!error" class="row mb-3">
			<!-- Filters -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2"><font-awesome-icon :icon="['fas', 'filter']" class="text-primary me-1" /> Filters</h4>
								<button v-if="Object.values(this.params).length > 4 && searchActive === ''" @click="clearFilters()" class="btn btn-sm btn-danger text-white me-2">
									Clear
									<font-awesome-icon :icon="['fas', 'times']" />
								</button>
								<button v-if="!searchSaving && haveParamsToSave() && searchActive === ''" @click="searchSaving = true" class="btn btn-sm btn-primary">
									Save search
								</button>
								<div v-if="searchSaving && searchActive === ''" class="save-search d-flex">
									<form @submit.prevent="storeSearch" class="d-flex">
										<input type="text" v-model="searchName" class="form-control form-control-sm ms-2" placeholder="enter search name" required />
										<button type="submit" class="btn btn-sm btn-primary ms-1">
											Save
										</button>
										<a role="button" @click="searchSaving = false" class="btn btn-sm ms-1">
											Cancel
										</a>
									</form>
								</div>
								<span v-if="searchActive !== ''" class="badge bg-success"
									>{{ searchActive }} <font-awesome-icon role="button" @click="clearFilters()" class="ms-2" :icon="['fas', 'times']"
								/></span>
							</div>
							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasSearches"
									aria-controls="offcanvasSearches"
									class="btn btn-outline-secondary btn-sm me-2"
								>
									Saved Searches <font-awesome-icon :icon="['fas', 'save']" class="me-1" />
								</button>
							</div>
						</div>

						<LPDataTableFiltersModern v-if="filtersUiMode === 'modern'" :filters="table.filters" v-on:getFilters="getFilters($event.filters)" />
						<LPDataTableFilters v-else :filters="table.filters" v-on:getFilters="getFilters($event.filters)" />
					</div>
				</div>
			</div>
			<!-- Table data -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2 text-capitalize">{{ model }}</h4>
								<a
									v-if="authUser.permissions.includes('MUNICIPALITY_CREATE')"
									data-bs-toggle="modal"
									data-bs-target="#create"
									class="btn btn-outline-primary btn-sm"
									>Add {{ model }} <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1"
								/></a>
							</div>

							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasTableSettings"
									aria-controls="offcanvasTableSettings"
									class="btn btn-outline-secondary btn-sm"
								>
									Table Settings <font-awesome-icon :icon="['fas', 'cogs']" class="me-1" />
								</button>
							</div>
						</div>
						<table :class="!loading && tableData.length > 0 ? 'table table-hover' : 'table table-hover loading'">
							<LPDataTableThead :thead="table.columns" :userColumns="userColumns" v-on:setOrder="setOrderBy($event.orderBy, $event.direction)" />
							<LPDataTableTbody
								:userColumns="userColumns"
								:authUser="authUser"
								:data="tableData"
								:tbody="table.columns"
								:model="model"
								:route="route"
								:rowInfo="true"
								v-on:showInformationModal="showInformationModal($event)"
							/>
						</table>
						<div v-if="!loading && tableData.length === 0" class="col-md-12 text-center">
							<h4>No data available</h4>
						</div>
						<div v-if="loading && tableData.length === 0" class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
						<div class="table-actions d-flex">
							<button data-bs-toggle="modal" data-bs-target="#exportModal" class="btn btn-success btn-sm me-2">
								Export <font-awesome-icon :icon="['fas', 'file-csv']" class="me-1" />
							</button>

							<button
								v-if="authUser.permissions.includes('CAMPAIGN_CREATE')"
								data-bs-toggle="modal"
								data-bs-target="#campaignModal"
								class="btn btn-secondary btn-sm me-2"
								@click="getCampaignMunicipalities()"
							>
								Create Campaign <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" />
							</button>
							<button
								v-if="authUser.permissions.includes('CARNIVORE_CREATE')"
								data-bs-toggle="modal"
								data-bs-target="#carnivoreModal"
								class="btn btn-warning btn-sm me-2 float-end"
							>
								🧑‍💻 Create Carnivore <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" />
							</button>
							<button
								v-if="authUser.permissions.includes('CAMPAIGN_CREATE')"
								data-bs-toggle="modal"
								data-bs-target="#campaignListModal"
								class="btn btn-secondary btn-sm me-2"
								@click="getCampaignMunicipalities(true)"
							>
								Create Campaign List <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" />
							</button>
						</div>
						<LPDataTablePagination :pagination="pagination" v-on:getItems="getItems($event.page)" />
					</div>
				</div>
			</div>
		</div>

		<div v-else class="row mb-3">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="alert alert-danger" role="alert">
							{{ error }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for displaying Data -->
		<div class="modal fade" id="dataInfoModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-body">
						<div>
							<div class="row border-bottom mb-2 pb-1">
								<div class="col-1">
									<h1>🏛️</h1>
								</div>
								<div class="col-6">
									<h4 class="mb-0">{{ dataInfo.full_name }}</h4>
									<span>{{ dataInfo.county }}, {{ dataInfo.state }}</span>
								</div>
								<div class="col-5">
									<div class="float-end">
										<a :href="dataInfo.wikipedia" target="_blank" class="btn btn-primary"
											><font-awesome-icon :icon="['fab', 'wikipedia-w']" class="me-2" /> Wikipedia</a
										>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-6">
									<p class="m-0 p-0 mb-2"><b>Population</b>: 🧑‍🤝‍🧑 {{ dataInfo.population }}</p>
									<p class="m-0 p-0 mb-2">
										<b>FIPS</b>:
										<a target="_blank" :href="'https://google.com/search?q=FIPS+' + dataInfo.fips">{{ dataInfo.fips }}</a>
									</p>
									<p class="m-0 p-0 mb-2"><b>FIPS full</b>: {{ dataInfo.fips_full }}</p>
									<p v-if="dataInfo.deliveries" class="m-0 p-0 mb-2"><b>Deliveries sent</b>: {{ dataInfo.deliveries.length }} 📨</p>
									<p v-if="dataInfo.contacts" class="m-0 p-0 mb-2"><b>Contacts</b>: {{ dataInfo.contacts.length }} 👤</p>
									<p class="m-0 p-0 mb-2" v-if="dataInfo.website">
										<b>Website</b>:
										<a v-if="dataInfo && dataInfo.website.includes('http')" :href="dataInfo.website" target="_blank">{{ dataInfo.website }} 🔗</a>
										<a v-else :href="'http://' + dataInfo.website" target="_blank">{{ 'http://' + dataInfo.website }} 🔗</a>
									</p>
								</div>
								<div class="col-6">
									<p class="m-0 p-0 mb-2"><b>State</b>: {{ dataInfo.state }}</p>
									<p class="m-0 p-0 mb-2"><b>City</b>: {{ dataInfo.city }}</p>
									<p class="m-0 p-0 mb-2"><b>Address</b>: {{ dataInfo.address_street }}</p>
									<p class="m-0 p-0 mb-4"><b>Zip</b>: {{ dataInfo.zip }}</p>

									<p class="m-0 p-0 mb-2">
										<b>TW customer</b>:
										<span v-if="dataInfo.tw_customer == 0" class="badge badge-danger bg-danger">No</span>
										<span v-if="dataInfo.tw_customer == 1" class="badge badge-success bg-success">Yes</span>
									</p>
									<p class="m-0 p-0 mb-2">
										<b>HG customer</b>:
										<span v-if="dataInfo.hg_customer == 0" class="badge badge-danger bg-danger">No</span>
										<span v-if="dataInfo.hg_customer == 1" class="badge badge-success bg-success">Yes</span>
									</p>
									<p class="m-0 p-0 mb-2">
										<b>ClerkMinutes</b>:
										<span v-if="dataInfo.heygov_clerk_minutes_status == 'paid'" class="badge badge-success bg-success">Paid</span>
										<span v-else-if="dataInfo.heygov_clerk_minutes_status == 'trial'" class="badge badge-warning bg-warning">Trial</span>
										<span v-else-if="dataInfo.heygov_clerk_minutes_status == 'canceled'" class="badge badge-danger bg-danger">Canceled</span>
										<span v-else class="badge badge-secondary bg-secondary">No</span>
										<span v-if="dataInfo.heygov_clerk_minutes_plan" class="ms-1 text-muted small">{{ dataInfo.heygov_clerk_minutes_plan }}</span>
									</p>
								</div>
							</div>

							<div class="row mb-4" v-if="dataInfo.tw_customer == 1">
								<div class="col-3">
									<p class="m-0 p-0 mt-2 fw-bold">311 🚩</p>
									{{ dataInfo.issues }}
								</div>
								<div class="col-3">
									<p class="m-0 p-0 mt-2 fw-bold">Boat launch 🛥️</p>
									{{ dataInfo.boat_launch }}
								</div>
								<div class="col-3">
									<p class="m-0 p-0 mt-2 fw-bold">Park rental 🏙️</p>
									{{ dataInfo.park_rental }}
								</div>
								<div class="col-3">
									<p class="m-0 p-0 mt-2 fw-bold">Online payments 💳</p>
									{{ dataInfo.online_payments }}
								</div>
								<div class="col-3">
									<p class="m-0 p-0 mt-2 fw-bold">Fillable forms 📝</p>
									{{ dataInfo.fillable_forms }}
								</div>
								<div class="col-3">
									<p class="m-0 p-0 mt-2 fw-bold">Chat box 💬</p>
									{{ dataInfo.chat_box }}
								</div>
								<div class="col-6">
									<p class="m-0 p-0 mt-2 fw-bold">Subscribe for alert notifications 📟</p>
									{{ dataInfo.alert_notifications }}
								</div>
							</div>
						</div>

						<!-- Tabs Navigation -->
						<ul class="nav nav-tabs mt-4" id="municipalityTabs" role="tablist">
							<li class="nav-item" role="presentation">
								<button
									class="nav-link active"
									id="campaigns-tab"
									data-bs-toggle="tab"
									data-bs-target="#campaigns"
									type="button"
									role="tab"
									aria-controls="campaigns"
									aria-selected="true"
								>
									📨 Campaigns <span class="badge bg-primary ms-1">{{ autoCampaigns ? autoCampaigns.length : 0 }}</span>
								</button>
							</li>
							<li class="nav-item" role="presentation">
								<button
									class="nav-link"
									id="contacts-tab"
									data-bs-toggle="tab"
									data-bs-target="#contacts"
									type="button"
									role="tab"
									aria-controls="contacts"
									aria-selected="false"
								>
									👤 Contacts <span class="badge bg-primary ms-1">{{ dataInfo.contacts ? dataInfo.contacts.length : 0 }}</span>
								</button>
							</li>
						</ul>

						<!-- Tabs Content -->
						<div class="tab-content" id="municipalityTabsContent">
							<!-- Campaigns Tab -->
							<div class="tab-pane fade show active" id="campaigns" role="tabpanel" aria-labelledby="campaigns-tab">
								<div class="my-3">
									<h5 class="mb-3">Campaign History</h5>
								</div>

								<div v-if="loadingAutoCampaigns" class="text-center py-4">
									<div class="spinner-border text-primary" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
									<p class="text-muted mt-2">Loading auto campaigns...</p>
								</div>

								<div v-else-if="!autoCampaigns || autoCampaigns.length === 0" class="text-center py-4">
									<p class="text-muted">This municipality has not participated in any auto campaigns</p>
								</div>

								<div class="table-responsive">
									<table class="table table-hover mt-2">
										<thead>
											<tr>
												<th>Campaign Name</th>
												<th width="50">Type</th>
												<th width="150">Preview</th>
												<th>Sequence</th>
												<th>Status</th>
												<th>Sent Date</th>
											</tr>
										</thead>
										<tbody>
											<template v-for="campaign in autoCampaigns">
												<tr :key="'auto-campaign-' + campaign.campaign_id + '-' + campaign.sent_at">
													<td class="align-middle">
														<div class="d-flex flex-column">
															<strong>{{ campaign.campaign_name }}</strong>
															<span class="campaign-type-badge" :class="getCampaignTypeClass(campaign.type)">
																<font-awesome-icon :icon="getCampaignTypeIcon(campaign.type)" class="me-1" style="font-size: 9px;" />
																{{ getCampaignTypeLabel(campaign.type) }}
															</span>
														</div>
													</td>
													<td class="align-middle text-center">
														<span class="mail-type-badge" :class="campaign.letter_pdf ? 'mail-letter' : 'mail-postcard'">
															<font-awesome-icon :icon="['fad', campaign.letter_pdf ? 'file-pdf' : 'image']" class="me-1" />
															{{ campaign.letter_pdf ? 'Letter' : 'Postcard' }}
														</span>
													</td>
													<td class="align-middle">
														<!-- Postcard Preview -->
														<template v-if="!campaign.letter_pdf && (campaign.postcard_front || campaign.postcard_back)">
															<div class="d-flex gap-1">
																<div v-if="campaign.postcard_front" class="postcard-thumbnail-wrapper">
																	<img
																		:src="storageUrl + campaign.postcard_front"
																		alt="Front"
																		class="postcard-thumbnail"
																		@error="handleImageError($event)"
																	/>
																	<a
																		:href="storageUrl + campaign.postcard_front"
																		target="_blank"
																		class="postcard-preview-overlay"
																		@click.stop
																	>
																		<img
																			:src="storageUrl + campaign.postcard_front"
																			alt="Front Preview"
																			class="postcard-preview-large"
																		/>
																	</a>
																	<small class="d-block text-center text-muted" style="font-size: 10px;">Front</small>
																</div>
																<div v-if="campaign.postcard_back" class="postcard-thumbnail-wrapper">
																	<img
																		:src="storageUrl + campaign.postcard_back"
																		alt="Back"
																		class="postcard-thumbnail"
																		@error="handleImageError($event)"
																	/>
																	<a
																		:href="storageUrl + campaign.postcard_back"
																		target="_blank"
																		class="postcard-preview-overlay"
																		@click.stop
																	>
																		<img
																			:src="storageUrl + campaign.postcard_back"
																			alt="Back Preview"
																			class="postcard-preview-large"
																		/>
																	</a>
																	<small class="d-block text-center text-muted" style="font-size: 10px;">Back</small>
																</div>
															</div>
														</template>
														<!-- Letter Preview -->
														<template v-else-if="campaign.letter_pdf">
															<a
																:href="storageUrl + campaign.letter_pdf"
																target="_blank"
																class="btn btn-sm btn-outline-danger"
																title="View PDF"
															>
																<font-awesome-icon :icon="['fas', 'file-pdf']" /> PDF
															</a>
														</template>
														<template v-else>
															<small class="text-muted">No preview</small>
														</template>
													</td>
													<td class="align-middle">
														<small>{{ campaign.sequence_name || '-' }}</small>
													</td>
													<td class="align-middle">
														<span class="badge" :class="getAutoCampaignStatusClass(campaign.status)">
															{{ getAutoCampaignStatusLabel(campaign.status) }}
														</span>
													</td>
													<td class="align-middle">
														<small>{{ campaign.sent_at ? formatDate(campaign.sent_at) : 'N/A' }}</small>
													</td>
												</tr>
											</template>
										</tbody>
									</table>
								</div>
							</div>

							<!-- Contacts Tab -->
							<div class="tab-pane fade" id="contacts" role="tabpanel" aria-labelledby="contacts-tab">
								<div class="d-flex justify-content-between align-items-center my-3">
									<h5 class="mb-0">Municipality Contacts</h5>
									<button
										v-if="authUser.permissions.includes('CONTACT_CREATE')"
										@click="addContactInInfoModal(dataInfo)"
										class="btn btn-primary btn-sm"
									>
										<font-awesome-icon :icon="['fas', 'plus']" class="me-1" /> Add Contact
									</button>
								</div>

								<div v-if="dataInfo.contacts && dataInfo.contacts.length === 0" class="text-center py-4">
									<p class="text-muted">There are no contacts</p>
								</div>

								<table :class="'table table-hover mt-2'" v-if="dataInfo.contacts && dataInfo.contacts.length > 0" :key="contactTableKey">
									<thead>
										<tr>
											<th>First name</th>
											<th>Last name</th>
											<th>Email</th>
											<th>Phone</th>
											<th>Title</th>
											<th width="120">Actions</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="contact in dataInfo.contacts">
											<tr :key="'edit-' + contact.id">
												<td class="align-middle">
													<template v-if="contact.edit && contact.edit === true">
														<input type="text" class="form-control form-control-sm" v-model="contact.first_name" required />
													</template>
													<template v-else>
														{{ contact.first_name }}
													</template>
												</td>
												<td class="align-middle">
													<template v-if="contact.edit && contact.edit === true">
														<input type="text" class="form-control form-control-sm" v-model="contact.last_name" required />
													</template>
													<template v-else>
														{{ contact.last_name }}
													</template>
												</td>
												<td class="align-middle">
													<template v-if="contact.edit && contact.edit === true">
														<input type="text" class="form-control form-control-sm" v-model="contact.email" required />
													</template>
													<template v-else>
														{{ contact.email }}
													</template>
												</td>
												<td class="align-middle">
													<template v-if="contact.edit && contact.edit === true">
														<input type="text" class="form-control form-control-sm" v-model="contact.phone" />
													</template>
													<template v-else>
														{{ contact.phone }}
													</template>
												</td>
												<td class="align-middle">
													<template v-if="contact.edit && contact.edit === true">
														<input type="text" class="form-control form-control-sm" v-model="contact.title" />
													</template>
													<template v-else>
														{{ contact.title }}
													</template>
												</td>
												<td class="align-middle">
													<template v-if="contact.edit">
														<button @click="saveContact(contact)" class="btn btn-success btn-sm">
															Save
														</button>
													</template>
													<template v-else>
														<button @click="editContact(contact)" class="btn btn-primary btn-sm me-2">
															<font-awesome-icon :icon="['fas', 'edit']" />
														</button>
													</template>
													<button @click="deleteContact(contact)" class="btn btn-sm btn-danger text-white me-2">
														<template v-if="contact.edit">cancel </template>
														<font-awesome-icon :icon="['fas', 'times']" />
													</button>
												</td>
											</tr>
										</template>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" @click="moreDetails()" class="btn btn-info">More details</button>
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for adding Data -->
		<div class="modal fade" id="create" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Create Municipality</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<small>
								🧑 Add municipality name (example: Town of Rome) and other info add on next page
							</small>
							<div class="form-group mt-2">
								<label for="">Municipality Name</label>
								<input type="text" class="form-control" v-model="newMunicipality.full_name" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
						<button type="submit" @click="createMunicipality()" class="btn btn-primary">Create</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for adding Filter -->
		<div class="modal fade" id="addFilter" tabindex="-1" aria-labelledby="addFilterLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="addFilter">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Add Filter</h5>
							<small class="ms-2">Adding new filter for {{ this.model }}</small>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body text-center">
							<h1>Will come soon 😉</h1>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<!-- <button type="submit" class="btn btn-primary">Save</button> -->
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for export -->
		<div class="modal fade" id="exportModal" tabindex="-1" aria-labelledby="exportModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Export {{ route }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-group mb-2">
							<label for="">Export Type</label>
							<select class="form-select" v-model="newExport.type">
								<option value="csv">CSV</option>
							</select>
						</div>
						<div class="form-group mb-2">
							<label for="">File Name</label>
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="File name" v-model="newExport.filename" />
								<span class="input-group-text" id="basic-addon2">.{{ newExport.type }}</span>
							</div>
						</div>
						<div class="form-group">
							<label for="">Columns to export</label>
							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="newExport.columnsType" value="visible" id="visibleColumnsRadio" checked />
								<label class="form-check-label" for="visibleColumnsRadio">
									Export visible columns
								</label>
							</div>
							<div class="my-2" v-if="newExport.columnsType === 'visible'">
								<div class="d-flex flex-wrap">
									<div :key="'column-available-' + column" v-for="column in newExport.exportColumns" class="mb-2 me-1">
										<span class="badge bg-success">{{ column }}</span>
									</div>
								</div>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="newExport.columnsType" value="custom" id="customColumnsRadio" />
								<label class="form-check-label" for="customColumnsRadio">
									Export custom columns
								</label>
							</div>
							<div class="my-2" v-if="newExport.columnsType === 'custom'">
								<div class="d-flex flex-wrap">
									<small class="w-100 mb-1">ℹ️ Click on column to include/exclude it from export</small>
									<div :key="'column-available-' + column" v-for="column in newExport.availableColumns" class="mb-2 me-1">
										<span role="button" @click="toggleExportColumn(column)" v-if="newExport.exportColumns.includes(column)" class="badge bg-success">{{
											column
										}}</span>
										<span role="button" @click="toggleExportColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
						<button v-if="!loadExporting && exportingFile === ''" @click="exportData()" type="submit" class="btn btn-primary">
							Create Export
						</button>
						<a v-if="!loadExporting && exportingFile !== ''" @click="downloadExport()" :href="exportingFile" class="btn btn-primary" download>
							Download
						</a>

						<button v-if="loadExporting" class="btn btn-primary" type="button" disabled>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for creating campaign -->
		<div class="modal fade" id="campaignModal" tabindex="-1" aria-labelledby="campaignModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="createCampaign">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Create Campaign</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-2">
								<label for="">Campaign Name</label>
								<div class="input-group mb-3">
									<input type="text" class="form-control" placeholder="Campaign name" v-model="newCampaign.name" required />
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="">Description</label>
								<div class="input-group mb-3">
									<textarea class="form-control" placeholder="Campaign description" v-model="newCampaign.description" />
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="">UTM Campaign</label>
								<div class="input-group mb-3">
									<utm-campaign-input v-model="newCampaign.utm_campaign" />
								</div>
							</div>
							<div class="form-group mb-2">
								<label>UTM Content</label>
								<utm-content-input v-model="newCampaign.utm_content" />
							</div>
							<div v-if="!loadingCampaignObjects">
								<span class="badge badge-primary bg-success w-100 py-3"
									><h4 class="m-0 p-0">{{ newCampaign.campaignObjects.length }} municipalities</h4></span
								>
							</div>
							<div v-else>
								<div class="d-flex justify-content-center">
									<div class="spinner-border" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">
								<font-awesome-icon :icon="['fas', loadingCampaingCreate ? 'spinner' : 'save']" :class="[loadingCampaingCreate ? 'fa-spin' : '']" /> Create
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for creating campaign list -->
		<div class="modal fade" id="campaignListModal" tabindex="-1" aria-labelledby="campaignListModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="createCampaignList">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Create Campaign List</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-2">
								<label for="">Campaign List Name</label>
								<div class="input-group mb-3">
									<input type="text" class="form-control" placeholder="Campaign list name" v-model="newCampaignList.name" required />
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="">Description</label>
								<div class="input-group mb-3">
									<textarea class="form-control" placeholder="Campaign list description" v-model="newCampaignList.description" />
								</div>
							</div>
							<div v-if="!loadingCampaignListObjects">
								<span class="badge badge-primary bg-success w-100 py-3"
									><h4 class="m-0 p-0">{{ newCampaignList.campaignObjects.length }} municipalities</h4></span
								>
							</div>
							<div v-else>
								<div class="d-flex justify-content-center">
									<div class="spinner-border" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="loadingCampaignListCreate">Close</button>
							<button type="submit" class="btn btn-primary" :disabled="loadingCampaignListCreate">
								<font-awesome-icon :icon="['fas', loadingCampaignListCreate ? 'spinner' : 'save']" :class="[loadingCampaignListCreate ? 'fa-spin' : '']" /> 
								{{ loadingCampaignListCreate ? 'Creating...' : 'Create' }}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for creating carnivore -->
		<div class="modal fade" id="carnivoreModal" tabindex="-1" aria-labelledby="carnivoreModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<form @submit.prevent="createCarnivore">
						<div class="modal-header">
							<div class="d-flex justify-content-start align-items-center">
								<h5 class="modal-title me-2">Create Carnivore</h5>
								<a href="javascript:void(0)" @click="addCustomMunicipalities = false" class="btn btn-primary btn-sm" v-if="addCustomMunicipalities">Back</a>
							</div>

							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body mb-0">
							<template v-if="!addCustomMunicipalities">
								<div class="form-group mb-1">
									<label for="">Carnivore Name</label>
									<div class="input-group mb-3">
										<input type="text" class="form-control" placeholder="Carnivore name" v-model="newCarnivore.name" required />
									</div>
								</div>

								<div class="form-group mb-1">
									<label for="">Description</label>
									<div class="input-group mb-3">
										<textarea class="form-control" placeholder="Carnivore description" v-model="newCarnivore.description" />
									</div>
								</div>

								<div class="form-group mb-1">
									<label for="">Priority</label>
									<select class="form-select" v-model="newCarnivore.priority">
										<option value="normal">Normal</option>
										<option value="medium">Medium</option>
										<option value="high">High</option>
									</select>
								</div>

								<div class="row mt-2">
									<div class="col-md-12">
										Chose fields for campaigns
									</div>
									<div class="col-md-6" v-for="field in newCarnivore.fields" :key="field.name">
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="field.active" :id="field.name" />
											<label class="form-check-label" :for="field.name">
												{{ field.label }}
											</label>
										</div>
									</div>
								</div>
							</template>

							<div class="row mb-3 bg-light p-2 mt-2" v-if="!addCustomMunicipalities">
								<div class="col-md-6">
									<div class="form-check">
										<input
											class="form-check-input"
											type="radio"
											v-model="carnivoreType"
											:value="'filters'"
											id="carnivoreFilters"
											@click="changeCarnivoreType('filters')"
										/>
										<label class="form-check-label" for="carnivoreFilters">
											Carnivore from filters
										</label>
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-check">
										<input
											class="form-check-input"
											type="radio"
											v-model="carnivoreType"
											:value="'custom'"
											id="carnivoreCustom"
											@click="changeCarnivoreType('custom')"
										/>
										<label class="form-check-label" for="carnivoreCustom">
											Custom carnivore
										</label>
									</div>
								</div>
							</div>

							<!-- Add municipalities from filters -->
							<div v-if="carnivoreType === 'filters'">
								<small>👋 Municipalities will be added from selected filters</small>
								<span class="badge badge-primary bg-success w-100 py-3"
									><h4 class="m-0 p-0">{{ pagination.total }} municipalities</h4></span
								>
							</div>
							<!-- Add custom municipalities -->
							<div v-else>
								<small v-if="!addCustomMunicipalities">👋 You need to add municipalities for carnivore</small>
								<a
									href="javascript:void(0)"
									class="btn btn-primary d-flex justify-content-center align-items-center"
									@click="addCustomMunicipalities = true"
									v-if="!addCustomMunicipalities"
									>Add municipalities</a
								>
								<template v-if="addCustomMunicipalities">
									<h5>Add municipalities for carnivore</h5>
									<!-- Select municipality if missing for type municipality -->
									<MunicipalityAdvancedSearch class="mb-2" :enableCsvUploadSearch="true" v-on:setMunicipality="addMunicipalityToCarnivore" />

									<div v-if="customMunicipalities.length > 0" style="max-height: 300px; overflow-y: auto;">
										<table class="table">
											<thead>
												<tr>
													<th>Name</th>
													<th>County</th>
													<th>State</th>
													<th>Population</th>
													<th width="30"></th>
												</tr>
											</thead>
											<tbody>
												<tr :key="municipality.id" v-for="municipality in customMunicipalities">
													<td>{{ municipality.full_name }}</td>
													<td>{{ municipality.county }}</td>
													<td>{{ municipality.state }}</td>
													<td>{{ municipality.population }}</td>
													<th width="30">
														<a href="javascript:void(0)" @click="removeFromMunicipality(municipality.id)" class="btn btn-sm btn-danger text-white">
															<font-awesome-icon :icon="['fas', 'times']" />
														</a>
													</th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="mt-2">
										<span class="badge badge-primary bg-success w-100 py-3 mt-3"
											><h4 class="m-0 p-0">{{ customMunicipalities.length }} municipalities</h4></span
										>
									</div>
								</template>
							</div>
						</div>
						<div class="modal-footer">
							<button v-if="!creatingCarnivoreLoader" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
								Close
							</button>
							<button
								v-if="!creatingCarnivoreLoader"
								:disabled="carnivoreType === 'custom' && customMunicipalities.length === 0"
								type="submit"
								class="btn btn-primary"
							>
								Create
							</button>
							<button v-else class="btn btn-primary" type="button" disabled>
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Loading...
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Offcanvas for Filters -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasFilters" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Filters settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				Filters settings
			</div>
		</div>

		<!-- Offcanvas for Searches -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasSearches" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Saved searches</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Your saved searches</h4>
				<p class="p-0"><small>ℹ️ Click on search to apply search filters to table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'user-searches-' + search.id" v-for="search in searches" class="mb-2 me-1">
							<span
								data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasSearches"
								aria-controls="offcanvasSearches"
								role="button"
								@click="applySearch(search)"
								class="badge bg-success"
								>{{ search.name }}</span
							>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Your saved searches for fast applying filters, you can add important ones to display above table (🚧 coming soon)</small>
			</div>
		</div>
		<!-- Offcanvas for Table Settings -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasTableSettings" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Table settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Display columns</h4>
				<p class="p-0"><small>ℹ️ Select which columns to display in table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'column-available-' + column" v-for="column in availableColumns" class="mb-2 me-1">
							<span role="button" @click="toggleUserColumn(column)" v-if="userColumns.includes(column)" class="badge bg-success">{{ column }}</span>
							<span role="button" @click="toggleUserColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Selected columns are automatically saved to your browser storage and will be used again when you come on this page</small>

				<h4 class="mt-3">Display {{ this.route }} per page</h4>
				<p class="p-0">
					<small>ℹ️ Select how many {{ this.route }} to display per page in table</small>
				</p>
				<div class="form-group w-75">
					<select v-model="userPerPage" @change="setUserPerPage()" class="form-select">
						<option value="10">10 per page</option>
						<option value="15">15 per page</option>
						<option value="20">20 per page</option>
						<option value="30">30 per page</option>
						<option value="50">50 per page</option>
						<option value="100">100 per page</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import UtmCampaignInput from '@/components/common/UtmCampaignInput'
import UtmContentInput from '@/components/common/UtmContentInput'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { Modal } from 'bootstrap'
import { handleErrors } from '../../actions/helpers'
import LPDataTablePagination from '@/components/lp-data-table/LPDataTablePagination'
import LPDataTableFilters from '@/components/lp-data-table/LPDataTableFilters'
import LPDataTableFiltersModern from '@/components/lp-data-table/LPDataTableFiltersModern'
import LPDataTableThead from '@/components/lp-data-table/LPDataTableThead'
import LPDataTableTbody from '@/components/lp-data-table/LPDataTableTbody'
import MunicipalityAdvancedSearch from '@/components/municipality/MunicipalityAdvancedSearch'
import { STATUS_CODES } from '@/constants/httpStatus'
import { USA_TIMEZONES } from '@/constants/timezones'

export default {
	name: 'Municipalities',
	components: {
		UtmCampaignInput, UtmContentInput,
		PageHeader,
		LPDataTablePagination,
		LPDataTableFilters,
		LPDataTableFiltersModern,
		LPDataTableThead,
		LPDataTableTbody,
		MunicipalityAdvancedSearch,
	},
	data() {
		return {
			route: 'municipalities',
			model: 'municipality',
			tableData: [],
			loading: false,
			error: '',
			newTableEntry: {},
			$createModal: null,
			$exportModal: null,
			$campaignModal: null,
			$campaignListModal: null,
			$carnivoreModal: null,
			$addFilterModal: null,
			pagination: {},
			page: this.$route.query.page || 1,
			orderBy: this.$route.query.orderBy || 'id',
			direction: this.$route.query.direction || 'asc',
			userPerPage: localStorage.getItem('municipality-per-page') || 20,
			filtersUiMode: 'default',
			filtersUiSettings: {
				default: 'default',
				overrides: {},
			},
			table: {
				columns: [
					{
						name: 'id',
						label: 'ID',
						sort: true,
						type: 'default',
					},
					{
						name: 'fips',
						label: 'FIPS',
						sort: false,
						type: 'google',
					},
					{
						name: 'state_fips',
						label: 'State FIPS',
						sort: false,
						type: 'default',
					},
					{
						name: 'county_fips',
						label: 'County FIPS',
						sort: false,
						type: 'default',
					},
					{
						name: 'place_fips',
						label: 'Place FIPS',
						sort: false,
						type: 'default',
					},
					{
						name: 'type',
						label: 'Type',
						sort: true,
						type: 'default',
					},
					{
						name: 'name',
						label: 'Name',
						sort: true,
						type: 'default',
					},
					{
						name: 'full_name',
						label: 'Full Name',
						sort: true,
						type: 'default',
					},
					{
						name: 'state',
						label: 'State',
						sort: true,
						type: 'default',
					},
					{
						name: 'county',
						label: 'County',
						sort: false,
						type: 'default',
					},
					{
						name: 'city',
						label: 'City',
						sort: false,
						type: 'default',
					},
					{
						name: 'zip',
						label: 'ZIP',
						sort: false,
						type: 'default',
					},
					{
						name: 'pobox',
						label: 'POBox',
						sort: false,
						type: 'default',
					},
					{
						name: 'address_street',
						label: 'Address Street',
						sort: false,
						type: 'default',
					},

					{
						name: 'deliverable',
						label: 'Deliverable',
						sort: true,
						type: 'default',
					},
					{
						name: 'pobox_check',
						label: 'POBox check',
						sort: true,
						type: 'default',
					},
					{
						name: 'mail_returned',
						label: 'Mail returned',
						sort: true,
						type: 'default',
					},
					{
						name: 'population',
						label: 'Population',
						sort: true,
						type: 'default',
					},
					{
						name: 'phone',
						label: 'Phone',
						sort: false,
						type: 'default',
					},
					{
						name: 'website',
						label: 'Website',
						sort: false,
						type: 'link',
					},
					{
						name: 'website_status_code',
						label: 'Website Status Code',
						sort: false,
						type: 'default',
					},
					{
						name: 'website_type',
						label: 'Website Type',
						sort: false,
						type: 'default',
					},
					{
						name: 'provider_fingerprints',
						label: 'Providers',
						sort: false,
						type: 'fingerprints',
					},
					{
						name: 'technology_fingerprints',
						label: 'Technologies',
						sort: false,
						type: 'fingerprints',
					},
					{
						name: 'hosting_fingerprints',
						label: 'Hosting',
						sort: false,
						type: 'fingerprints',
					},
					{
						name: 'cms_fingerprints',
						label: 'CMS',
						sort: false,
						type: 'fingerprints',
					},
					{
						name: 'product_fingerprints',
						label: 'Products',
						sort: false,
						type: 'fingerprints',
					},
					{
						name: 'timezone',
						label: 'Timezone',
						sort: false,
						type: 'default',
					},
					{
						name: 'tw_customer',
						label: 'Town Web Customer',
						sort: false,
						type: 'default',
					},
					{
						name: 'hg_customer',
						label: 'HeyGov Customer',
						sort: false,
						type: 'default',
					},
					{
						name: 'heygov_clerk_minutes_status',
						label: 'ClerkMinutes',
						sort: false,
						type: 'default',
					},
					{
						name: 'email',
						label: 'Email',
						sort: false,
						type: 'default',
					},

					{
						name: 'wikipedia',
						label: 'Wikipedia',
						sort: false,
						type: 'link',
					},
					{
						name: 'competitor',
						label: 'Competitor',
						sort: false,
						type: 'default',
					},
					{
						name: 'competitor_hg',
						label: 'Competitor HG',
						sort: false,
						type: 'default',
					},
					{
						name: 'food_stamp',
						label: 'Food stamp',
						sort: false,
						type: 'percent',
					},
					{
						name: 'lob_id',
						label: 'LOB ID',
						sort: false,
						type: 'default',
					},
					{
						name: 'source',
						label: 'Source',
						sort: false,
						type: 'default',
					},
					{
						name: 'last_mail_date',
						label: 'Last Mail Date',
						sort: false,
						type: 'default',
					},
					{
						name: 'last_email_date',
						label: 'Last Email Date',
						sort: false,
						type: 'default',
					},
					{
						name: 'created_at',
						label: 'Created',
						sort: false,
						type: 'default',
					},
					{
						name: 'updated_at',
						label: 'Updated',
						sort: false,
						type: 'default',
					},
					{
						name: 'actions',
						label: 'Actions',
						sort: false,
						type: 'actions',
						width: 100,
						buttons: [
							{
								type: 'default',
								label: 'View',
								action: '',
								class: 'btn-secondary',
								permission: 'MUNICIPALITY_ACCESS',
							},
							{
								type: 'default',
								label: 'Edit',
								action: '',
								class: 'btn-primary',
								permission: 'MUNICIPALITY_UPDATE',
							},
							{
								type: 'default',
								label: 'Delete',
								action: '',
								class: 'btn-danger',
								permission: 'MUNICIPALITY_DELETE',
							},
						],
					},
				],
				filters: [
					{
						display: true,
						name: 'search',
						label: 'Search',
						type: 'text',
						placeholder: 'enter text and press enter',
						colClass: 'col-3',
						value: this.$route.query.search || '',
					},
					{
						display: true,
						name: 'type',
						label: 'Type',
						type: 'select',
						placeholder: 'All types',
						colClass: 'col-2',
						value: this.$route.query.type || '',
						options: [
							{
								id: 'Town',
								name: 'Town',
							},
							{
								id: 'City',
								name: 'City',
							},
							{
								id: 'Township',
								name: 'Township',
							},
							{
								id: 'Village',
								name: 'Village',
							},
							{
								id: 'Borough',
								name: 'Borough',
							},
						],
					},
					{
						display: true,
						name: 'state',
						label: 'State',
						type: 'multiselect',
						placeholder: 'All states',
						colClass: 'col-3',
						options: [],
						optionValue: true,
						optionsEndpoint: `municipalities/states`,
						value: this.$route.query.state || [],
					},
					{
						display: true,
						name: 'county',
						label: 'County',
						type: 'multiselect',
						placeholder: 'All counties',
						colClass: 'col-4',
						options: [],
						value: this.$route.query.county || [],
					},
					{
						display: true,
						name: 'population',
						label: 'Population',
						type: 'range',
						placeholder: '',
						colClass: 'col-3',
						min: 0,
						max: 99999999,
						from: this.$route.query.frompopulation || '',
						to: this.$route.query.topopulation || '',
					},
					{
						display: true,
						name: 'tw_customer',
						label: 'TW',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.tw_customer || '',
						options: [
							{
								id: '0',
								name: 'No',
							},
							{
								id: '1',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'hg_customer',
						label: 'HG',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.hg_customer || '',
						options: [
							{
								id: '0',
								name: 'No',
							},
							{
								id: '1',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'heygov_clerk_minutes_status',
						label: 'ClerkMinutes',
						type: 'select',
						placeholder: 'Any',
						colClass: 'col-2',
						value: this.$route.query.heygov_clerk_minutes_status || '',
						options: [
							{
								id: 'paid',
								name: 'Paid',
							},
							{
								id: 'trial',
								name: 'Trial',
							},
							{
								id: 'canceled',
								name: 'Canceled',
							},
						],
					},
					{
						display: true,
						name: 'deliverable',
						label: 'Address deliverable',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.deliverable || '',
						options: [
							{
								id: '0',
								name: 'No',
							},
							{
								id: '1',
								name: 'Yes',
							},
						],
					},
					{
						display: true,
						name: 'food_stamp',
						label: 'Food Stamp',
						type: 'range',
						placeholder: '%',
						colClass: 'col-3',
						min: 0,
						max: 100,
						from: this.$route.query.fromfood_stamp || '',
						to: this.$route.query.tofood_stamp || '',
					},
					{
						display: true,
						name: 'issues',
						label: '311',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.issues || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'boat_launch',
						label: 'Boat launch',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.boat_launch || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'park_rental',
						label: 'Park rental',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.park_rental || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'online_payments',
						label: 'Online payments',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.online_payments || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'fillable_forms',
						label: 'Fillable forms',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.fillable_forms || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'chat_box',
						label: 'Chat box',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.chat_box || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'alert_notifications',
						label: 'Alert notifications',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.alert_notifications || '',
						options: [
							{
								id: 'no',
								name: 'No',
							},
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'maybe',
								name: 'Maybe',
							},
						],
					},
					{
						display: true,
						name: 'source',
						label: 'Source',
						type: 'text',
						placeholder: '',
						colClass: 'col-2',
						value: this.$route.query.source || '',
					},
					{
						display: true,
						name: 'competitor',
						label: 'Competitor (Legacy)',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.competitor || '',
						options: [
							{
								id: 'GovOffice',
								name: 'GovOffice',
							},
							{
								id: 'CivicPlus',
								name: 'CivicPlus',
							},
						],
					},
					{
						display: true,
						name: 'competitor_hg',
						label: 'Competitor HeyGov',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.competitor_hg || '',
						options: [
							{
								id: 'PSN',
								name: 'PSN',
							},
						],
					},
					{
						display: true,
						name: 'website_type',
						label: 'Website Type',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.website_type || '',
						options: [
							{
								id: 'any',
								name: 'Any',
							},
							{
								id: 'has_website',
								name: 'Has Website',
							},
							{
								id: 'none',
								name: 'No Website',
							},
							{
								id: 'gov',
								name: '.gov Website',
							},
							{
								id: 'non_gov',
								name: 'Non-.gov Website',
							},
						],
					},
					{
						display: true,
						name: 'website_status_code',
						label: 'Website Status',
						type: 'multiselect',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.website_status_code || [],
						options: STATUS_CODES.map(status => status.value),
					},
					{
						display: true,
						name: 'provider',
						label: 'Provider',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.provider || '',
						options: [],
					},
					{
						display: true,
						name: 'technology',
						label: 'Technology',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.technology || '',
						options: [],
					},
					{
						display: true,
						name: 'hosting',
						label: 'Hosting Provider',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.hosting || '',
						options: [],
					},
					{
						display: true,
						name: 'cms',
						label: 'CMS',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.cms || '',
						options: [],
					},
					{
						display: true,
						name: 'product',
						label: 'Product',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.product || '',
						options: [],
					},
					{
						display: true,
						name: 'muni_name_exists',
						label: 'Name Exists in Website',
						type: 'select',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.muni_name_exists || '',
						options: [
							{
								id: 'yes',
								name: 'Yes',
							},
							{
								id: 'no',
								name: 'No',
							},
						],
					},
					{
						display: true,
						name: 'timezone',
						label: 'Timezone',
						type: 'multiselect',
						placeholder: 'All timezones',
						colClass: 'col-3',
						value: this.$route.query.timezone || [],
						options: USA_TIMEZONES,
					},
				],
			},
			params: {},
			userColumns: JSON.parse(localStorage.getItem(`municipality-columns`)) || ['id', 'type', 'full_name', 'state', 'county', 'city', 'population'],
			availableColumns: ['id'],
			searchName: '',
			searchSaving: false,
			searchActive: '',
			searches: [],
			newExport: {
				type: 'csv',
				columnsType: 'visible',
				filename: '',
				availableColumns: ['id'],
				exportColumns: JSON.parse(localStorage.getItem(`municipality-columns`)) || ['id', 'type', 'full_name', 'state', 'county', 'city', 'population'],
			},
			loadExporting: false,
			exportingFile: '',
			$dataInfoModal: null,
			dataInfo: {},
			newCampaign: {
				name: '',
				description: '',
				utm_campaign: '',
				utm_content: '',
				filters: '',
				municipalities_count: '',
				clients: true,
				objects_type: 'municipality',
				campaignObjects: [],
			},
			newCampaignList: {
				name: '',
				description: '',
				filters: '',
				municipalities_count: '',
				objects_type: 'municipality',
				campaignObjects: [],
			},
			loadingCampaignObjects: false,
			loadingCampaignListObjects: false,
			loadingCampaingCreate: false,
			loadingCampaignListCreate: false,
			newCarnivore: {
				name: '',
				campaign_id: null,
				type: 'default',
				priority: 'normal',
				description: '',
				workers: null,
				fields: [
					{
						name: 'contacts',
						label: 'Contacts',
						active: true,
					},
					{
						name: 'email',
						label: 'Email',
						active: true,
					},
					{
						name: 'phone',
						label: 'Phone',
						active: true,
					},
					{
						name: 'county',
						label: 'County',
						active: true,
					},
					{
						name: 'city',
						label: 'City',
						active: true,
					},
					{
						name: 'zip',
						label: 'Zip',
						active: true,
					},
					{
						name: 'address_street',
						label: 'Address street / PO Box',
						active: true,
					},
					{
						name: 'population',
						label: 'Population',
						active: true,
					},
					{
						name: 'issues',
						label: 'Issues',
						active: false,
					},
					{
						name: 'boat_launch',
						label: 'Boat launch',
						active: false,
					},
					{
						name: 'park_rental',
						label: 'Park rental',
						active: false,
					},
					{
						name: 'online_payments',
						label: 'Online payments',
						active: false,
					},
					{
						name: 'fillable_forms',
						label: 'Fillable forms',
						active: false,
					},
					{
						name: 'chat_box',
						label: 'Chat box',
						active: false,
					},
					{
						name: 'alert_notifications',
						label: 'Alert notifications',
						active: false,
					},
					{
						name: 'competitor',
						label: 'Town Web Competitor',
						active: false,
					},
					{
						name: 'competitor_hg',
						label: 'HeyGov Competitor',
						active: false,
					},
				],
				status: 'new',
				data: null,
				filters: '',
				municipalities_count: '',
				municipalities: [],
			},
			newContact: {
				municipality_id: null,
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
				address: '',
				title: '',
				source: 'mc2',
			},
			contactTableKey: 1,
			creatingCarnivoreLoader: false,
			carnivoreType: 'filters',
			customMunicipalities: [],
			addCustomMunicipalities: false,
			newMunicipality: {
				full_name: '',
			},
			autoCampaigns: [],
			loadingAutoCampaigns: false,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.loadFiltersUiSettings()
		this.table.filters.forEach(filter => {
			if (filter.value && filter.value !== '' && filter.value.length > 0) {
				this.params[filter.name] = filter.value
			} else {
				delete this.params[filter.name]
			}

			if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
				this.params['from' + filter.name] = filter.from
				this.params['to' + filter.name] = filter.to
			} else {
				delete this.params['from' + filter.name]
				delete this.params['to' + filter.name]
			}
		})
		this.getCountyOptions()
		this.getDetectionPatternOptions()
		this.getTableColumns()
		this.getTableData(true)
		this.getSearches()
	},
	mounted() {
		this.$createModal = new Modal('#create')
		this.$addFilterModal = new Modal('#addFilter')
		this.$exportModal = new Modal('#exportModal')
		this.$dataInfoModal = new Modal('#dataInfoModal')
		this.$campaignModal = new Modal('#campaignModal')
		this.$campaignListModal = new Modal('#campaignListModal')
		this.$carnivoreModal = new Modal('#carnivoreModal')
	},
	methods: {
		async loadFiltersUiSettings() {
			try {
				const { data } = await restApi.get('/settings', { params: { name: 'municipalitiesFiltersUi', type: 'settings' } })
				if (data && data.data) {
					this.filtersUiSettings = JSON.parse(data.data)
					if (!this.filtersUiSettings.default) {
						this.filtersUiSettings.default = 'default'
					}
					if (!this.filtersUiSettings.overrides) {
						this.filtersUiSettings.overrides = {}
					}
				}
			} catch (error) {
				console.error(error)
			} finally {
				const override = this.filtersUiSettings.overrides?.[this.authUser.id]
				const overrideMode = typeof override === 'string' ? override : override?.mode
				this.filtersUiMode = overrideMode || this.filtersUiSettings.default || 'default'
			}
		},
		// Get table Columns
		getTableColumns() {
			restApi
				.post('/helper/table-columns', { table: this.route })
				.then(({ data }) => {
					this.newExport.availableColumns = data.map(column => column.name)
					this.availableColumns = data.map(column => column.name)
					this.availableColumns.push('actions')

					const additionalColumns = [
						'website_status_code',
						'website_type',
						'provider_fingerprints',
						'technology_fingerprints',
						'hosting_fingerprints',
						'cms_fingerprints',
						'product_fingerprints',
					]
					additionalColumns.forEach(column => {
						this.availableColumns.push(column)
						this.newExport.availableColumns.push(column)
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Get table data from API
		getTableData(first = false) {
			this.loading = true

			this.params = {
				...this.params,
				page: this.page,
				orderBy: this.orderBy,
				direction: this.direction,
				perPage: localStorage.getItem(`${this.model}-per-page`) || 20,
			}

			// Add hardRefresh parameter if present in query params
			if (this.$route.query.hardRefresh) {
				this.params.hardRefresh = this.$route.query.hardRefresh
			}

			restApi
				.get(`/${this.route}`, { params: this.params })
				.then(({ data }) => {
					this.tableData = data.data
					this.pagination = data
					delete this.pagination.data
					this.loading = false
					if (!first) {
						this.$router.push({ path: this.$router.currentPath, query: this.params })
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Adding new filter
		addFilter() {
			this.$addFilterModal.hide()
		},

		// Go to user page
		viewUser(user) {
			this.$router.push('/users/' + user.id)
		},

		// Get items from page that returned from LPDataTablePagination
		getItems(page) {
			this.page = page
			this.getTableData()
		},

		// Set direction
		setOrderBy(orderBy, direction) {
			this.orderBy = orderBy
			this.direction = direction
			this.getTableData()
		},

		// Get filters from LPDataTableFilters component
		getFilters(filters) {
			this.page = ''
			this.searchActive = ''
			filters.forEach(filter => {
				if (filter.value && filter.value !== '' && filter.value.length > 0) {
					this.params[filter.name] = filter.value
				} else {
					delete this.params[filter.name]
				}

				// Setting filter if its type is range
				if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
					this.params['from' + filter.name] = filter.from
					this.params['to' + filter.name] = filter.to
				} else {
					delete this.params['from' + filter.name]
					delete this.params['to' + filter.name]
				}
			})
			this.getCountyOptions()
			this.getTableData()
		},

		// Toggle user column
		toggleUserColumn(column) {
			if (this.userColumns.includes(column)) {
				this.userColumns = this.userColumns.filter(c => c !== column)
			} else {
				this.userColumns.push(column)
			}
			this.updateUserColumns()
		},

		// Update user columns
		updateUserColumns() {
			localStorage.setItem(`${this.model}-columns`, JSON.stringify(this.userColumns))
		},

		// Get user saved searches
		getSearches() {
			let params = {
				user_id: this.authUser.id,
				model: this.model,
			}
			restApi
				.get('/searches', { params })
				.then(({ data }) => {
					data.forEach(d => {
						d.data = JSON.parse(d.data)
						return d
					})
					this.searches = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Enable saving if some filters are set
		haveParamsToSave() {
			if (Object.values(this.params).length > 4) {
				return true
			} else {
				return false
			}
		},

		// Get user saved searches
		storeSearch() {
			let dataParams = this.params
			restApi
				.post('/searches', {
					user_id: this.authUser.id,
					model: `${this.model}`,
					name: this.searchName,
					data: JSON.stringify(dataParams),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.searches.push(data)
					this.searchActive = this.searchName
					this.searchSaving = false
					this.$swal.fire({
						icon: 'success',
						title: 'Search successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Apply saved search to table
		applySearch(search) {
			// Reset all before applying saved search
			this.params = {}
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'daterange') {
					filter.value = ''
				} else {
					filter.from = ''
					filter.to = ''
				}
			})
			// Apply saved search
			this.params = search.data
			let paramsArray = Object.keys(search.data)
			this.table.filters.forEach(filter => {
				if (paramsArray.includes(filter.name) && filter.type !== 'range') {
					filter.value = this.params[filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'range') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'daterange') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
			})
			this.searchActive = search.name
			this.getTableData()
		},

		// Clear all filters
		clearFilters() {
			this.params = {}
			this.searchActive = ''
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'multiselect') {
					filter.value = ''
				}
				if (filter.type === 'multiselect') {
					filter.value = []
				}
				if (filter.type === 'range' || filter.type === 'daterange') {
					filter.from = ''
					filter.to = ''
				}
			})
			this.getCountyOptions()
			this.getTableData()
		},

		// Toggle export column
		toggleExportColumn(column) {
			if (this.newExport.exportColumns.includes(column)) {
				this.newExport.exportColumns = this.newExport.exportColumns.filter(c => c !== column)
			} else {
				this.newExport.exportColumns.push(column)
			}
		},

		// Export table Data
		exportData() {
			this.loadExporting = true
			this.newExport.exportColumns = this.newExport.exportColumns.filter(column => column !== 'actions')
			restApi
				.post(`/${this.route}/export`, {
					params: JSON.stringify(this.params),
					columns: JSON.stringify(this.newExport.exportColumns),
					filename: this.newExport.filename,
				})
				.then(({ data }) => {
					this.loadExporting = false
					this.exportingFile = this.storageUrl + '/tmp/' + data.file
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Download exported Data
		downloadExport() {
			this.$exportModal.hide()
			this.newExport.filename = ''
			this.exportingFile = ''
		},

		// Set user per page
		setUserPerPage() {
			localStorage.setItem(`${this.model}-per-page`, this.userPerPage)
			this.getTableData()
		},

		showInformationModal(event) {
			// Reset auto campaigns when opening a new municipality
			this.autoCampaigns = []
			this.loadingAutoCampaigns = true

			restApi
				.get(`/${event.route}/${event.id}`)
				.then(({ data }) => {
					this.dataInfo = data
					this.dataInfo.contacts.forEach(contact => {
						contact.edit = false
					})
					this.$dataInfoModal.show()

					// Load auto campaigns immediately after opening modal
					this.loadAutoCampaigns(event.id)
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loading = false
					this.loadingAutoCampaigns = false
				})
		},

		moreDetails() {
			this.$dataInfoModal.hide()
			this.$router.push('/municipalities/edit/' + this.dataInfo.id)
		},

		// Get county options for selected state
		getCountyOptions() {
			if (this.params.state) {
				restApi.post('municipalities/counties', { state: this.params.state }).then(({ data }) => {
					data = data.filter(county => county !== null)
					this.counties = data
					let filter = this.table.filters.find(f => f.name === 'county')
					filter.options = data
				})
			} else {
				let filter = this.table.filters.find(f => f.name === 'county')
				filter.options = []
				filter.disabled = true
			}
		},

		// Get all filtered clients for campaign
		getCampaignMunicipalities(ids = false) {
			this.loadingCampaignObjects = true
			this.params = {
				...this.params,
				page: this.page,
				orderBy: this.orderBy,
				direction: this.direction,
				perPage: localStorage.getItem(`${this.model}-per-page`) || 20,
				idOnly: ids,
			}
			restApi
				.get('/municipalities/all', { params: this.params })
				.then(({ data }) => {
					this.newCampaign.campaignObjects = data
					this.loadingCampaignObjects = false
					this.newCampaignList.campaignObjects = data
					this.loadingCampaignListObjects = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Create campaign
		createCampaign() {
			this.loadingCampaingCreate = true
			this.newCampaign.filters = JSON.stringify(this.params)
			this.newCampaign.municipalities_count = this.pagination.total
			// Store new campaign
			restApi
				.post(`/campaigns`, this.newCampaign)
				.then(({ data }) => {
					this.$campaignModal.hide()
					this.$router.push(`/campaigns/edit/${data.id}`)
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Create campaign list
		createCampaignList() {
			this.loadingCampaignListCreate = true
			this.newCampaignList.filters = JSON.stringify(this.params)
			// campaign-data-lists
			restApi
				.post(`/campaign-data-lists`, this.newCampaignList)
				.then(({ data }) => {
					this.$campaignListModal.hide()
					this.loadingCampaignListCreate = false
					this.$swal.fire({
						icon: 'success',
						title: 'Campaign data list ' + data.name + ' successfully created!',
						timer: 3000,
					})
					// Clean modal data
					this.newCampaignList.name = ''
					this.newCampaignList.description = ''
					this.newCampaignList.filters = ''
					this.newCampaignList.campaignObjects = []
					this.newCampaignList.campaignObjects_count = 0
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loadingCampaignListCreate = false
				})
		},

		// Create carnivore
		createCarnivore() {
			this.creatingCarnivoreLoader = true
			let nCarnivore = JSON.parse(JSON.stringify(this.newCarnivore))
			nCarnivore.filters = JSON.stringify(this.params)
			if (this.carnivoreType === 'custom') {
				nCarnivore.municipalities_count = this.newCarnivore.municipalities_count
			} else {
				nCarnivore.municipalities_count = this.pagination.total
			}

			nCarnivore.dataType = this.carnivoreType
			// Store new carnivore
			restApi
				.post(`/carnivores`, nCarnivore)
				.then(({ data }) => {
					this.$carnivoreModal.hide()
					this.creatingCarnivoreLoader = false
					this.$router.push(`/carnivores/edit/${data.id}`)
					this.$swal.fire({
						icon: 'success',
						title: 'Carnivore successfully created!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Add contact in info modal
		addContactInInfoModal(municipality) {
			this.newContact.edit = true
			municipality.contacts.push(this.newContact)
		},

		// Save contact
		saveContact(contact) {
			if (contact.municipality_id === null) {
				// Store new client data
				if (this.authUser.permissions.includes('CONTACT_CREATE')) {
					contact.municipality_id = this.dataInfo.id
					restApi
						.post(`/contacts`, contact)
						.then(({ data }) => {
							this.$swal.fire({
								icon: 'success',
								title: 'Contact successfully created!',
								timer: 3000,
							})
							contact.id = data.id
							contact.edit = false
							this.contactTableKey = this.contactTableKey + 1
							this.dataInfo.contacts.pop()
							this.dataInfo.contacts.push(data)
							this.newContact.municipality_id = null
							this.newContact.first_name = ''
							this.newContact.last_name = ''
							this.newContact.email = ''
							this.newContact.phone = ''
							this.newContact.address = ''
							this.newContact.title = ''
							this.newContact.source = 'mc2'
						})
						.catch(error => {
							this.$swal.fire({
								icon: 'error',
								title: handleErrors(error, ''),
								timer: 6000,
							})
						})
				} else {
					this.$swal.fire({
						icon: 'error',
						title: "You don't have permission to perform this action!",
						timer: 6000,
					})
				}
			} else {
				// Update client data
				if (this.authUser.permissions.includes('CONTACT_UPDATE')) {
					restApi
						.put(`/contacts/${contact.id}`, contact)
						.then(() => {
							this.$swal.fire({
								icon: 'success',
								title: 'Contact successfully updated!',
								timer: 3000,
							})
							contact.edit = false
							this.contactTableKey = this.contactTableKey + 1
						})
						.catch(error => {
							this.$swal.fire({
								icon: 'error',
								title: handleErrors(error, ''),
								timer: 6000,
							})
						})
				} else {
					this.$swal.fire({
						icon: 'error',
						title: "You don't have permission to perform this action!",
						timer: 6000,
					})
				}
			}
		},

		// Edit contact
		editContact(contact) {
			this.contactTableKey = this.contactTableKey + 1
			contact.edit = true
		},

		// Delete contact
		deleteContact(contact) {
			if (contact.id) {
				if (contact.edit === true) {
					contact.edit = false
					this.contactTableKey = this.contactTableKey + 1
				} else {
					if (confirm('Remove this client') == true) {
						if (this.authUser.permissions.includes('CONTACT_DELETE')) {
							restApi
								.delete(`/contacts/${contact.id}`)
								.then(() => {
									this.$swal.fire({
										icon: 'success',
										title: 'Contact successfully deleted!',
										timer: 3000,
									})
									this.dataInfo.contacts = this.dataInfo.contacts.filter(c => c.id !== contact.id)
									this.contactTableKey = this.contactTableKey + 1
								})
								.catch(error => {
									this.$swal.fire({
										icon: 'error',
										title: handleErrors(error, ''),
										timer: 6000,
									})
								})
						} else {
							this.$swal.fire({
								icon: 'error',
								title: "You don't have permission to perform this action",
								timer: 4000,
							})
						}
					}
				}
			} else {
				this.dataInfo.contacts = this.dataInfo.contacts.filter(c => c.id !== contact.id)
				this.contactTableKey = this.contactTableKey + 1
			}
		},

		// Add municipalities from MunicipalityAdvancedSearch to array
		addMunicipalityToCarnivore(municipality) {
			if (!this.newCarnivore.municipalities.includes(municipality.id)) {
				this.customMunicipalities.push(municipality)
				this.newCarnivore.municipalities.push(municipality.id)
				this.newCarnivore.municipalities_count = this.newCarnivore.municipalities.length
			}
		},

		// Remove municipality
		removeFromMunicipality(id) {
			this.customMunicipalities = this.customMunicipalities.filter(m => m.id !== id)
			this.newCarnivore.municipalities = this.newCarnivore.municipalities.filter(m => m.id !== id)
			this.newCarnivore.municipalities_count = this.newCarnivore.municipalities.length
		},

		// Change carnivore type custom or filters
		changeCarnivoreType(type) {
			if (type === 'filters') {
				this.newCarnivore.municipalities = []
				this.newCarnivore.municipalities_count = this.pagination.total
			} else {
				this.newCarnivore.municipalities_count = this.newCarnivore.municipalities.length
			}
		},

		// Create municipality
		createMunicipality() {
			console.log(this.newMunicipality)
			restApi
				.post(`/municipalities`, this.newMunicipality)
				.then(({ data }) => {
					this.$router.push('municipalities/edit/' + data)
					this.$swal.fire({
						icon: 'success',
						title: 'Municipality successfully created!',
						timer: 3000,
					})
					this.$createModal.hide()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Get detection pattern options (providers, technologies, hosting)
		getDetectionPatternOptions() {
			restApi
				.get('/platform-fingerprints', { params: { perPage: 100000, select: 'id,name,type' } })
				.then(({ data }) => {
					const patterns = data.data

					// Update provider options
					let providerFilter = this.table.filters.find(f => f.name === 'provider')
					if (providerFilter) {
						const providers = patterns.filter(p => p.type === 'provider')
						providerFilter.options = [{ id: 'none', name: 'No Provider' }, ...providers.map(p => ({ id: `${p.id}`, name: p.name }))]
					}

					// Update technology options
					let technologyFilter = this.table.filters.find(f => f.name === 'technology')
					if (technologyFilter) {
						const technologies = patterns.filter(p => p.type === 'technology')
						technologyFilter.options = [{ id: 'none', name: 'No Technology' }, ...technologies.map(t => ({ id: `${t.id}`, name: t.name }))]
					}

					// Update hosting options
					let hostingFilter = this.table.filters.find(f => f.name === 'hosting')
					if (hostingFilter) {
						const hostings = patterns.filter(p => p.type === 'hosting')
						hostingFilter.options = [{ id: 'none', name: 'No Hosting' }, ...hostings.map(h => ({ id: `${h.id}`, name: h.name }))]
					}

					// Update cms options
					let cmsFilter = this.table.filters.find(f => f.name === 'cms')
					if (cmsFilter) {
						const cms = patterns.filter(p => p.type === 'cms')
						cmsFilter.options = [{ id: 'none', name: 'No CMS' }, ...cms.map(c => ({ id: `${c.id}`, name: c.name }))]
					}

					// Update product options
					let productFilter = this.table.filters.find(f => f.name === 'product')
					if (productFilter) {
						const products = patterns.filter(p => p.type === 'product')
						productFilter.options = [{ id: 'none', name: 'No Product' }, ...products.map(p => ({ id: `${p.id}`, name: p.name }))]
					}
				})
				.catch(error => {
					console.error('Error fetching detection patterns:', error)
				})
		},

		// Load auto campaigns for municipality
		loadAutoCampaigns(municipalityId) {
			if (!municipalityId) {
				this.loadingAutoCampaigns = false
				return
			}

			restApi
				.get(`/municipalities/${municipalityId}/campaign-history`)
				.then(({ data }) => {
					this.autoCampaigns = data
					this.loadingAutoCampaigns = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, 'Failed to load auto campaigns'),
						timer: 6000,
					})
					this.autoCampaigns = []
					this.loadingAutoCampaigns = false
				})
		},

		// Get status class for auto campaign badge
		getAutoCampaignStatusClass(status) {
			const statusMap = {
				completed: 'bg-success',
				processing: 'bg-info',
				pending: 'bg-warning',
				failed: 'bg-danger',
				sent: 'bg-success',
				error: 'bg-danger',
				in_transit: 'bg-info',
				delivered: 'bg-success',
			}
			return statusMap[status] || 'bg-secondary'
		},

		// Get status label for display
		getAutoCampaignStatusLabel(status) {
			if (status === 'completed') {
				return 'sent'
			}
			return status
		},

		// Get campaign type class
		getCampaignTypeClass(type) {
			// Normalize type string
			const normalizedType = type.toLowerCase()

			const typeMap = {
				'auto_campaign': 'type-triggered',
				'triggered_campaign': 'type-triggered',
				'sequenced_campaign': 'type-sequenced',
				'legacy_campaign': 'type-legacy',
			}
			return typeMap[normalizedType] || 'type-unknown'
		},

		// Get campaign type label
		getCampaignTypeLabel(type) {
			// Normalize type string
			const normalizedType = type.toLowerCase()

			const labelMap = {
				'auto_campaign': 'Auto',
				'triggered_campaign': 'Auto',
				'sequenced_campaign': 'Sequenced',
				'legacy_campaign': 'Legacy',
			}
			return labelMap[normalizedType] || type
		},

		// Get campaign type icon
		getCampaignTypeIcon(type) {
			// Normalize type string
			const normalizedType = type.toLowerCase()

			const iconMap = {
				'auto_campaign': ['fad', 'bolt'],
				'triggered_campaign': ['fad', 'bolt'],
				'sequenced_campaign': ['fad', 'list-ol'],
				'legacy_campaign': ['fad', 'clock-rotate-left'],
			}
			return iconMap[normalizedType] || ['fad', 'question']
		},

		// Format date
		formatDate(dateString) {
			if (!dateString) return 'N/A'
			try {
				const date = new Date(dateString)
				return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
			} catch (e) {
				return dateString
			}
		},

		// Handle image error
		handleImageError(event) {
			const img = event.target
			img.style.display = 'none'

			// Create placeholder
			const placeholder = document.createElement('div')
			placeholder.className = 'postcard-thumbnail postcard-no-image'
			placeholder.innerHTML = '<span>No Image</span>'

			// Replace image with placeholder
			img.parentNode.insertBefore(placeholder, img)
		},
	},
}
</script>

<style scoped>
/* Campaign Type Badges */
.campaign-type-badge {
	display: inline-flex;
	align-items: center;
	padding: 2px 8px;
	font-size: 9px;
	font-weight: 500;
	border-radius: 10px;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	margin-top: 4px;
	width: fit-content;
}

.type-triggered {
	background-color: rgba(74, 144, 226, 0.12);
	color: #357abd;
	border: 1px solid rgba(74, 144, 226, 0.25);
}

.type-sequenced {
	background-color: rgba(82, 196, 26, 0.12);
	color: #389e0d;
	border: 1px solid rgba(82, 196, 26, 0.25);
}

.type-legacy {
	background-color: rgba(140, 140, 140, 0.12);
	color: #595959;
	border: 1px solid rgba(140, 140, 140, 0.25);
}

.type-unknown {
	background-color: rgba(140, 140, 140, 0.12);
	color: #595959;
	border: 1px solid rgba(140, 140, 140, 0.25);
}

/* Mail Type Badges */
.mail-type-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	font-size: 11px;
	font-weight: 500;
	border-radius: 12px;
	transition: all 0.2s ease;
}

.mail-letter {
	background-color: rgba(255, 77, 79, 0.1);
	color: #cf1322;
	border: 1px solid rgba(255, 77, 79, 0.3);
}

.mail-postcard {
	background-color: rgba(114, 46, 209, 0.1);
	color: #531dab;
	border: 1px solid rgba(114, 46, 209, 0.3);
}

/* Postcard thumbnail styles */
.postcard-thumbnail-wrapper {
	position: relative;
	display: inline-block;
}

.postcard-thumbnail {
	width: 100px;
	height: 60px;
	object-fit: cover;
	border: 2px solid #e9ecef;
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.postcard-thumbnail:hover {
	border-color: #667eea;
	box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
	transform: scale(1.05);
}

/* No image placeholder */
.postcard-no-image {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f5f5;
	border: 2px dashed #d9d9d9;
	color: #999;
	font-size: 10px;
	font-weight: 500;
	text-align: center;
	cursor: default;
}

.postcard-no-image:hover {
	border-color: #d9d9d9;
	box-shadow: none;
	transform: none;
}

/* Hover preview overlay */
.postcard-preview-overlay {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s ease, visibility 0.3s ease;
	z-index: 9999;
	pointer-events: none;
	cursor: pointer;
	text-decoration: none;
}

.postcard-thumbnail-wrapper:hover .postcard-preview-overlay {
	opacity: 1;
	visibility: visible;
	pointer-events: auto;
}

.postcard-preview-large {
	width: 400px;
	height: auto;
	max-height: 500px;
	object-fit: contain;
	border: 4px solid #667eea;
	border-radius: 12px;
	box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
	background: white;
	padding: 6px;
}

/* Ensure preview stays within viewport */
@media (max-width: 768px) {
	.postcard-preview-large {
		width: 300px;
	}
}
</style>
